import React, { useState } from 'react'
import AddBookingConfirm from '../addBookingConfirm/AddBookingConfirm';
import '../addService/AddService.css'


const AddService = () => {
        const [selectedContentType, setSelectedContentType] = useState("TermsConditions");
  return (

    <div className='dashboard-content-box add-service-sec'>
        <div className='inner-add-services d-flex flex-wrap'>
            <div className='left-booking-box'>
                <div className='add-service-top booking-service'>
                    <h2>Service</h2>
                    <div className='box-border booking-border-box d-flex justify-content-between align-items-center'>
                        <p>Exclusive Content</p>
                        <span className='text-icons'>From $100</span>
                    </div>
                </div>
                <div className='booking-timing-box'>
                    <div className='top-booking-timing d-flex flex-wrap'>
                        <div className='form-group'>
                            <label htmlFor="">Price Offer (must be over $100)</label>
                            <input type="text" className="form-control" id="" placeholder="$00.00" />
                        </div>
                    </div>
                </div>
                <div className='booking-location '>
                    <h2>Select Content Type</h2>
                    <div className='location-box mb-3'>
                        <ul className='radio-box-checked'>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="ContentType" id="Content1" value="Content1" checked={selectedContentType==="Content1" } onChange={()=> setSelectedContentType("Content1")} />
                                    <label className="form-check-label" htmlFor="Content1">Photo</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="ContentType" id="Content2" value="Content2" checked={selectedContentType==="Content2" } onChange={()=> setSelectedContentType("Content2")} />
                                    <label className="form-check-label" htmlFor="Content2">Video</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="ContentType" id="Content3" value="Content3" checked={selectedContentType==="Content3" } onChange={()=> setSelectedContentType("Content3")} />
                                    <label className="form-check-label" htmlFor="Content3">Voice Recording</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='booking-bottom-form'>
                    <div className="form-group d-flex flex-wrap align-items-center">
                        <label for="" className="col-form-label ">Description </label>
                        <div className="form-box">
                            <textarea name="" rows="5" cols="40" id="" placeholder=''></textarea>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className='right-booking-box sticky-md-top'>
                <AddBookingConfirm />
            </div>
        </div>

    </div>
  )
}

export default AddService